import { HttpParams } from '@angular/common/http';

export function createHttpParams(paramsObj: Record<string, any>): HttpParams {
  let params = new HttpParams();

  Object.entries(paramsObj).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params = params.set(key, value);
    }
  });

  return params;
}
